export default __webpack_public_path__ + "static/media/Connecticut5Closed.ef705736.jpg";